import React, { useState, useEffect } from 'react';

const EmpresaSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      id: 1,
      image: '/imgs/empresa-slide1.jpg',
      overlayImage: '/imgs/slider-sprano-logo-transp.png',
      text: 'Soprano Gráfica es una empresa de primera línea en el mercado dedicada a la fabricación de envases de microcorrugado, corrugado, y cartulina, impresos en offset y flexo.'
    },
    {
      id: 2,
      image: '/imgs/empresa-slide2-1.jpg',
      overlayImage: '/imgs/slider-sello-85.png',
      text: 'Más de 85 años en el mercado, fabricando soluciones de empaque para todo tipo de productos, nos avalan para cumplir con las exigencias de nuestros clientes.'
    },
    {
      id: 3,
      image: '/imgs/empresa-slide3.jpg',
      overlayImage: '/imgs/slider-sprano-logo-transp.png',
      text: 'Materias primas de alta calidad y primera marcas con estándares internacionales.'
    },
    {
      id: 4,
      image: '/imgs/empresa-slide4-1.jpg',
      overlayImage: '/imgs/slider-sprano-logo-transp.png',
      text: 'Un calificado equipo de trabajo favorece el desarrollo y fabricación de diversos tipos de envases. Su departamento de desarrollo responde a las exigencias del mercado y de los clientes.'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const goToSlide = (index) => setCurrentSlide(index);
  const goToPrevious = () => setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  const goToNext = () => setCurrentSlide((prev) => (prev + 1) % slides.length);

  return (
    <section id="empresa" className="section empresa-section">
      <div className="empresa-slider-container">
        <button className="empresa-slider-nav empresa-slider-nav-prev" onClick={goToPrevious}>‹</button>

        <div className="empresa-slider-track" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
          {slides.map((slide, index) => (
            <div key={slide.id} className="empresa-slider-slide">
              <img src={slide.image} alt={`Empresa slide ${index + 1}`} className="empresa-slider-image" />

              {slide.overlayImage && (
                <img src={slide.overlayImage} alt="Overlay" className="empresa-slider-overlay-image" />
              )}

              {slide.text && (
                <div className="empresa-slider-text-overlay">
                  <p className="empresa-slider-text">{slide.text}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <button className="empresa-slider-nav empresa-slider-nav-next" onClick={goToNext}>›</button>

        <div className="empresa-slider-indicators">
          {slides.map((_, index) => (
            <button
              key={index}
              className={`empresa-slider-indicator ${index === currentSlide ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
              aria-label={`Ir al slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default EmpresaSlider;


